import { ConditionValueSetPicker } from "./condition-value-set-picker"

const PERIODS = ["Hour", "Day", "Week", "Month", "Year"]

export function ConditionValueFrequencyPeriod({ value, onChange }) {
    return (
        <ConditionValueSetPicker
            value={value}
            onChange={onChange}
            options={PERIODS}
            placeholder="Select frequency periods..."
        />
    )
}
